'use client'

// lib files
import { ShowRowContent } from '@/lib/types/api/show-data';
import type { ShowBadgeFlags } from '@/components/ShowPoster/ShowPoster';

// components
import FeaturedShowsRow from './FeaturedShowsRow';
import RecommendedShowsRow from '@/components/RecommendedShowsRow/RecommendedShowsRow';

interface TopPicksOrFeaturedShowsRowProps {
  featuredShows: ShowRowContent[];
  showBadgeFlags?: ShowBadgeFlags;
}

const TopPicksOrFeaturedShowsRow = (props: TopPicksOrFeaturedShowsRowProps) => {
  const { featuredShows, showBadgeFlags } = props;

  return (
    <RecommendedShowsRow
      fallback={
        <FeaturedShowsRow
          shows={featuredShows}
          showBadgeFlags={showBadgeFlags}
        />
      }
      useMainRecommendedShows={true}
      showBadgeFlags={showBadgeFlags}
    />
  );
}

export default TopPicksOrFeaturedShowsRow;
